import React, { useRef } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const DQRulesTable = ({
  title,
  titleColor = 'bg-indigo-500',
  rules = [],
  showArguments = false,
  emptyMessage = 'No rules defined'
}) => {
  const tableRef = useRef(null);

  const scrollTable = (direction) => {
    if (tableRef.current) {
      const scrollAmount = 200;
      tableRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
      <div className="p-6 border-b border-gray-200 flex items-center justify-between">
        <div>
          <h3 className="text-lg font-bold text-gray-800 mb-2 flex items-center">
            <div className={`w-[5px] h-6 ${titleColor} rounded mr-3`}></div>
            {title}
          </h3>
          <p className="text-sm pl-4 text-gray-600">
            {rules.length} rules defined
          </p>
        </div>
        <div className="flex items-center gap-1 text-gray-400 text-sm">
          <button
            onClick={() => scrollTable('left')}
            className="p-1 hover:bg-gray-100 rounded transition-colors"
            title="Scroll left"
          >
            <ChevronLeft className=" h-5" />
          </button>
          <span>Scroll</span>
          <button
            onClick={() => scrollTable('right')}
            className="p-1 hover:bg-gray-100 rounded transition-colors"
            title="Scroll right"
          >
            <ChevronRight className=" h-5" />
          </button>
        </div>
      </div>
      <div className="overflow-x-auto" ref={tableRef}>
        <table className="w-full">
          <thead>
            <tr className="bg-gray-50">
              <th className="text-left py-3 px-6 text-sm font-semibold text-gray-700">Rule Name</th>
              <th className="text-left py-3 px-6 text-sm font-semibold text-gray-700">Description</th>
              <th className="text-left py-3 px-6 text-sm font-semibold text-gray-700">Dimension</th>
              <th className="text-left py-3 px-6 text-sm font-semibold text-gray-700">Check Name</th>
              <th className="text-left py-3 px-6 text-sm font-semibold text-gray-700">Arguments</th>
              <th className="text-left py-3 px-6 text-sm font-semibold text-gray-700">Sql</th>

            </tr>
          </thead>
          <tbody>
            {rules.length > 0 ? (
              rules.map((rule, index) => (
                <tr key={rule.rules_id || index} className="border-t border-gray-100">
                  <td className="py-3 px-6 text-sm text-gray-900">{rule.rule_name || 'N/A'}</td>
                  <td className="py-3 px-6 text-sm text-gray-700">{rule.rule_description || 'N/A'}</td>
                  <td className="py-3 px-6">
                    <span className="px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-700">
                      {rule.dimension_name || 'N/A'}
                    </span>
                  </td>
                  <td className="py-3 px-6 text-sm text-gray-700">{rule.check_name || 'N/A'}</td>
                  <td className="py-3 px-6 text-sm text-gray-700 font-mono ">{rule.arguments || 'N/A'}</td>
                  <td className="py-3 px-6 text-sm text-gray-700 font-mono ">{rule.sql || 'N/A'}</td>

                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={showArguments ? 5 : 4} className="py-6 text-center text-gray-500">{emptyMessage}</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DQRulesTable;

